import type React from 'react'
import { useTranslation } from 'react-i18next'

import { TimeRangeInput } from '../../../__generated__/api'
import TimerangeSelect from '../DateSelect/TimerangeSelect'

import Fieldset from './Fieldset'

interface Props {
  name: string
  value: TimeRangeInput | null
  handleChange: (event: React.ChangeEvent<{ value: TimeRangeInput }>) => void
}

const TimerangeSelectWrapper: React.FC<React.PropsWithChildren<Props>> = ({
  name,
  value,
  handleChange,
}) => {
  const { t } = useTranslation()

  const onChange = (timeRange: TimeRangeInput | null) =>
    handleChange({
      target: {
        name,
        value: timeRange,
      },
    } as unknown as React.ChangeEvent<{ value: TimeRangeInput }>)

  return (
    <Fieldset legend={t('component.filterOptions.timeRangeSelect.legend')} expanded={true}>
      <TimerangeSelect value={value} onChange={onChange} />
    </Fieldset>
  )
}

export default TimerangeSelectWrapper
